import React, { useState } from 'react';
import { Card, Tabs, Typography } from 'antd';
import {
  BookOutlined,
  TeamOutlined,
  DollarOutlined,
  FileTextOutlined,
} from '@ant-design/icons';
import { KnowledgeEntries } from './KnowledgeEntries';
import { CooperationRecords } from './CooperationRecords';
import { PricingBenchmarks } from './PricingBenchmarks';
import { ProposalTemplates } from './ProposalTemplates';

const { Title } = Typography;

export const KnowledgeBase: React.FC = () => {
  const [activeTab, setActiveTab] = useState('entries');

  const tabItems = [
    {
      key: 'entries',
      label: (
        <span>
          <BookOutlined />
          知识条目
        </span>
      ),
      children: <KnowledgeEntries />,
    },
    {
      key: 'cooperation',
      label: (
        <span>
          <TeamOutlined />
          合作记录
        </span>
      ),
      children: <CooperationRecords />,
    },
    {
      key: 'pricing',
      label: (
        <span>
          <DollarOutlined />
          报价基准
        </span>
      ),
      children: <PricingBenchmarks />,
    },
    {
      key: 'templates',
      label: (
        <span>
          <FileTextOutlined />
          提案模板
        </span>
      ),
      children: <ProposalTemplates />,
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Title level={4} style={{ marginBottom: 24 }}>
        知识库管理
      </Title>

      <Card bordered={false}>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={tabItems}
          size="large"
        />
      </Card>
    </div>
  );
};
